import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCheckoutPage, LazyFrontendAccountCustomerGroupRegistrationPage, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyLanguageSwitcher, LazyProfessionalStoreCheckoutPage, LazySwProductListingFilter, LazySwProductListingFilters, LazyAccountAddressCard, LazyAccountAddressForm, LazyAccountChangeEmail, LazyAccountChangePassword, LazyAccountLoginForm, LazyAccountMenu, LazyAccountOrder, LazyAccountOrderDetails, LazyAccountOrderDownloads, LazyAccountOrderItem, LazyAccountOrderLineItem, LazyAccountOrderSummary, LazyAccountPersonalData, LazyAccountRecoverPassword, LazyAccountRegisterForm, LazyAccountResetPasswordForm, LazyCheckoutCartItem, LazyCheckoutFormRegistration, LazyCheckoutPromotionCode, LazyCheckoutSideCart, LazyCheckoutConfigFormGroupCoverLetterConfig, LazyCheckoutConfigFormGroupRegistrationConfig, LazyCmsSwListingProductPrice, LazyCmsSwProductCard, LazyCmsSwProductPrice, LazyCmsSwSharedPrice, LazyCmsElementProductListing, LazyCmsElementSidebarFilter, LazyCmsSectionSidebar, LazyErrorsRoutingNotFound, LazyLayoutBreadcrumbs, LazyLayoutCheckoutHeader, LazyLayoutFooter, LazyLayoutHeader, LazyLayoutNotification, LazyLayoutNotifications, LazyLayoutSideMenu, LazyLayoutSidebar, LazyListingFiltersListingFilter, LazyListingFilters, LazyListingFiltersPrice, LazyListingFiltersProperties, LazyListingFiltersRating, LazyListingFiltersShippingFree, LazyProductAddToCart, LazyProductGallery, LazyProductPrice, LazyProductStatic, LazyProductSuggestSearch, LazyProductUnits, LazyProductVariantConfigurator, LazySharedAccountAddressForm, LazySharedAccountAddresses, LazySharedCountryStateInput, LazySharedListingProductPrice, LazySharedModal, LazySharedPagination, LazySharedPrice, LazyUnoIcon, LazyCmsGenericBlock, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsPage, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCrossSelling, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockGalleryBuybox, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextBubble, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockProductThreeColumn, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockTextTwoColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementBuyBox, LazyCmsElementCategoryNavigation, LazyCmsElementCrossSelling, LazyCmsElementCustomForm, LazyCmsElementForm, LazyCmsElementImage, LazyCmsElementImageGallery, LazyCmsElementImageSlider, LazyCmsElementManufacturerLogo, LazyCmsElementProductBox, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductName, LazyCmsElementProductSlider, LazyCmsElementText, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyCmsSectionDefault } from '#components'
const lazyGlobalComponents = [
  ["CheckoutPage", LazyCheckoutPage],
["FrontendAccountCustomerGroupRegistrationPage", LazyFrontendAccountCustomerGroupRegistrationPage],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["LanguageSwitcher", LazyLanguageSwitcher],
["ProfessionalStoreCheckoutPage", LazyProfessionalStoreCheckoutPage],
["SwProductListingFilter", LazySwProductListingFilter],
["SwProductListingFilters", LazySwProductListingFilters],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressForm", LazyAccountAddressForm],
["AccountChangeEmail", LazyAccountChangeEmail],
["AccountChangePassword", LazyAccountChangePassword],
["AccountLoginForm", LazyAccountLoginForm],
["AccountMenu", LazyAccountMenu],
["AccountOrder", LazyAccountOrder],
["AccountOrderDetails", LazyAccountOrderDetails],
["AccountOrderDownloads", LazyAccountOrderDownloads],
["AccountOrderItem", LazyAccountOrderItem],
["AccountOrderLineItem", LazyAccountOrderLineItem],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPersonalData", LazyAccountPersonalData],
["AccountRecoverPassword", LazyAccountRecoverPassword],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountResetPasswordForm", LazyAccountResetPasswordForm],
["CheckoutCartItem", LazyCheckoutCartItem],
["CheckoutFormRegistration", LazyCheckoutFormRegistration],
["CheckoutPromotionCode", LazyCheckoutPromotionCode],
["CheckoutSideCart", LazyCheckoutSideCart],
["CheckoutConfigFormGroupCoverLetterConfig", LazyCheckoutConfigFormGroupCoverLetterConfig],
["CheckoutConfigFormGroupRegistrationConfig", LazyCheckoutConfigFormGroupRegistrationConfig],
["CmsSwListingProductPrice", LazyCmsSwListingProductPrice],
["CmsSwProductCard", LazyCmsSwProductCard],
["CmsSwProductPrice", LazyCmsSwProductPrice],
["CmsSwSharedPrice", LazyCmsSwSharedPrice],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["LayoutBreadcrumbs", LazyLayoutBreadcrumbs],
["LayoutCheckoutHeader", LazyLayoutCheckoutHeader],
["LayoutFooter", LazyLayoutFooter],
["LayoutHeader", LazyLayoutHeader],
["LayoutNotification", LazyLayoutNotification],
["LayoutNotifications", LazyLayoutNotifications],
["LayoutSideMenu", LazyLayoutSideMenu],
["LayoutSidebar", LazyLayoutSidebar],
["ListingFiltersListingFilter", LazyListingFiltersListingFilter],
["ListingFilters", LazyListingFilters],
["ListingFiltersPrice", LazyListingFiltersPrice],
["ListingFiltersProperties", LazyListingFiltersProperties],
["ListingFiltersRating", LazyListingFiltersRating],
["ListingFiltersShippingFree", LazyListingFiltersShippingFree],
["ProductAddToCart", LazyProductAddToCart],
["ProductGallery", LazyProductGallery],
["ProductPrice", LazyProductPrice],
["ProductStatic", LazyProductStatic],
["ProductSuggestSearch", LazyProductSuggestSearch],
["ProductUnits", LazyProductUnits],
["ProductVariantConfigurator", LazyProductVariantConfigurator],
["SharedAccountAddressForm", LazySharedAccountAddressForm],
["SharedAccountAddresses", LazySharedAccountAddresses],
["SharedCountryStateInput", LazySharedCountryStateInput],
["SharedListingProductPrice", LazySharedListingProductPrice],
["SharedModal", LazySharedModal],
["SharedPagination", LazySharedPagination],
["SharedPrice", LazySharedPrice],
["UnoIcon", LazyUnoIcon],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsPage", LazyCmsPage],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementForm", LazyCmsElementForm],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementText", LazyCmsElementText],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["CmsSectionDefault", LazyCmsSectionDefault]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
